import React from 'react';
import { CalculationSpec } from '../../../../../../../../../types/Quotes';
import CurrencyInput from './inputs/CurrencyInput';
import DefaultInput from './inputs/DefaultInput';
import SelectInput from './inputs/SelectInput';

interface Props {
  calcSpec: CalculationSpec;
}

const OfferParameterSpec: React.FC<Props> = ({ calcSpec }) => {
  const props = {
    calculationSpec: calcSpec,
  };

  switch (calcSpec.input_type) {
    case 'CURRENCY':
      return <CurrencyInput {...props} />;
    case 'SELECT':
      return <SelectInput {...props} />;
    default:
      return <DefaultInput {...props} />;
  }
};

export default OfferParameterSpec;
